export const BookmarkedContentListSwrFetchKey = "bookmarkedContentList";
export const BookmarkedListV1Key = "bookmarkedList";
export const BookmarkedLastSyncKey = "bookmarkedListTimeStamp"; // Key from v1 refs: https://project.scmp.tech/product/web/scmp-pwa/-/blob/master/scmp-app/src/universal/utils/bookmark/index.ts#L73
